import {
    ButtonGroup,
    Dropdown,
} from "react-bootstrap";
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    MissionStore,
    reSetSatDetails,
    setSatelliteClone,
    setSatelliteEdit,
    setSatellites,
    setSatellitesDetails,
} from '../../../store/MissionSlice';
import { navigateTo } from '../../../utils/commonFunctions';
import MissionService from '../../../service/MissionService';
import OperateModal from "../Operate/modal/OperateModal";
import CustomToolTip from "../../CommonComponents/CustomToolTip";
import '../MissionDetails.css';
import CreateGroupModel from "../Satellites/CreateGroupModel";
import ConfirmationDialog from "../../CommonComponents/confirmation_dialog/ConfirmationDialog";
import { showToastMessage } from "../../../utils/commonFunctions";
import { AddNewEntityButton } from "../../CommonComponents/svgs/Svgs";

interface Props {
    showBtnGroup: any;
    setShowBtnGroup: (showBtnGroup: any) => void;
    loading: boolean
    setLoading: (loading: boolean) => void
}

const Satellites = ({ showBtnGroup, setShowBtnGroup, loading, setLoading }: Props) => {
    const params = useParams();
    const { mission_name, mission_id, tab_name } = params
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);
    const SatellitesDetails: any = useSelector((state: { mission: MissionStore }) => state.mission.SatellitesDetails);

    const satelliteEdit = useSelector((state: { mission: MissionStore }) => state.mission.satelliteEdit);
    const satelliteClone = useSelector((state: { mission: MissionStore }) => state.mission.satelliteClone);

    const flagGroup = userData?.['feature-allowed']?.['satelliteGroups'] === 'Yes' ? true : false;
    const maxSatelliteCount = userData?.['feature-allowed']?.['noOfSatellitesMaxLimit']
    const [satelliteData, setSatelliteData] = React.useState<any>({})
    const [satellite_name, setSatellite_name] = React.useState(mission_name);
    const [satellite_des, setSatellite_des] = React.useState('');
    const [satellite_count, setSatelliteCount] = React.useState<any>(null);
    const [altitude, setAltitude] = React.useState(450);
    const [inclination, setInclination] = React.useState(37);
    const [phasing, setPhasing] = React.useState<number | null>(null);
    const [phasingType, setPhasingType] = React.useState<"TA" | "RAAN">("TA");
    const [openSatModel, setOpenSatModal] = React.useState(false);
    const [openDeleteModel, setOpenDeleteModal] = React.useState(false);
    const [promoteSatellite, setPromoteSatellite] = React.useState(false);
    const [eligibleSatellites, setEligibleSatellites] = React.useState<string[]>([]);

    useEffect(() => {
        dispatch(reSetSatDetails())
        reset_selected_sat_data()
    }, [])

    const [hasTruetwin, setHasTruetwin] = useState(false)

    const navigateTo_Sat_details = (sat) => {
        navigateTo(`${mission_name}/${mission_id}/sat_details/${sat?.['name']}/${sat?.['uniqueId']}/SateliiteProfile?sub_tab=telemetry`, navigate);
    }

    const navigate_to_view_satellite = (sat) => {
        navigateTo(`${mission_name}/${mission_id}/view_satellite/${sat?.['name']}/${sat?.['uniqueId']}/view`, navigate)
    }

    const navigate_to_operate = () => {
        navigateTo(`${mission_name}/${mission_id}/operate-dashboard`, navigate)
    }

    const get_satellite_data = async () => {
        if (tab_name !== 'Satellites') return
        setLoading(true);
        try {
            const [satRes, infoRes, promoteRes] = await Promise.allSettled([
                MissionService.get_satellites_by_mission_id(mission_id),
                MissionService.getMissionSatInfo(mission_id),
                MissionService.get_eligile_sat_for_promote(mission_id)
            ]);
            if (satRes.status === "fulfilled" && satRes.value?.data) {
                dispatch(setSatellites(satRes.value.data));
            } else {
                dispatch(setSatellites([]));
                if (satRes.status === "rejected") console.error("Satellites fetch failed:", satRes.reason);
            }
            if (infoRes.status === "fulfilled" && infoRes.value?.data) {
                dispatch(setSatellitesDetails(infoRes.value.data));
            } else {
                dispatch(setSatellitesDetails([]));
                if (infoRes.status === "rejected") {
                    console.error("Satellite Info fetch failed:", infoRes.reason);
                    showToastMessage("error", "Something went wrong while fetching satellite info");
                }
            }
            if (promoteRes.status === "fulfilled" && promoteRes.value?.data?.data) {
                const eligibleIds = promoteRes.value.data.data.map((item: any) => item.uniqueId);
                setEligibleSatellites(eligibleIds);
            } else {
                setEligibleSatellites([]);
            }
        } catch (err) {
            console.error("Unexpected error in get_satellite_data:", err);
            dispatch(setSatellites([]));
            dispatch(setSatellitesDetails([]));
            setEligibleSatellites([]);
        } finally {
            setLoading(false);
        }
    };


    const deletesatellite = async (satelliteData) => {
        setLoading(true);
        try {
            const res = await MissionService.delete_satellite(satelliteData?.['uniqueId'], mission_id);
            if (res) {
                await get_satellite_data();
                showToastMessage('success', res.data);
            } else {
                setLoading(false);
            }
        } catch (err: any) {
            showToastMessage('error', err?.response?.data ?? 'Failed to delete satellite');
            setLoading(false);
        }
    };

    const create_new_satellite = async () => {
        if (satellite_name !== '') {
            setLoading(true)
            let sat = {
                "name": satellite_name,
                "missionId": mission_id,
                "description": satellite_des,
                "groupType": {
                    "type": 'Group',
                    "groupKind": "Symmetric"
                },
                satCount: parseInt(`${satellite_count}`),
                altitude: parseFloat(`${altitude}`),
                inclination: parseFloat(`${inclination}`),
                ...(parseInt(`${satellite_count}`) > 1 && {
                    phasingType: phasingType === "TA" ? "InterPlanePhasing" : "PlanePhasing",
                    phasingAngle: parseFloat(`${phasing}`)
                })
            }

            MissionService.create_new_satellites(sat, mission_id)
                ?.then((res) => {
                    if (res.data) {
                        navigateTo(`${mission_name}/${mission_id}/${res?.data}/add_new_payload`, navigate)
                    }
                })
                .catch((err) => {
                    setLoading(false)
                    if (err.response?.data) {
                        showToastMessage('error', err.response?.data);
                    } else {
                        showToastMessage('error', "Something went wrong while creating satellite. Please try again.");
                    }
                });
        } else {
            showToastMessage('error', 'Please enter satellite name')
        }
    }

    const reset_selected_sat_data = () => {
        if (satelliteEdit) {
            dispatch(setSatelliteEdit(false))
        } else if (satelliteClone) {
            dispatch(setSatelliteClone(false))
        }
        setSatellite_name('')
        setSatellite_des('')
        setSatelliteData({})
    }

    const clone_existing_satellite_group = async (groupId: string) => {
        setLoading(true);
        try {
            const res = await MissionService.clone_satellite_group(mission_id, groupId);
            if (res?.data) {
                await get_satellite_data();
                showToastMessage('success', res.data?.message ?? res?.data);
            } else {
                setLoading(false);
            }
        } catch (err: any) {
            showToastMessage('error', err?.response?.data ?? 'Failed to clone satellite group');
            setLoading(false);
        }
    };

    const handleEditSatelliteGroup = (satellite) => {
        if (satellite?.satelliteGroup?.['trueTwinIds'] && satellite?.satelliteGroup?.['trueTwinIds']?.length > 0) {
            setHasTruetwin(true)
        } else {
            setHasTruetwin(false)
        }
        dispatch(setSatelliteEdit(true))
        setAltitude(satellite?.satelliteGroup?.referenceOrbitParameters?.altitude)
        setInclination(satellite?.satelliteGroup?.referenceOrbitParameters?.inclination)
        setSatelliteCount(satellite?.satelliteGroup?.satCount)
        setPhasing(parseFloat(parseFloat(satellite?.satelliteGroup?.phasingAngle).toFixed(2)));
        setPhasingType(satellite?.satelliteGroup?.phasingType === "PlanePhasing" ? "RAAN" : "TA")
        setSatellite_name(satellite?.satelliteGroup?.['name']);
        setSatellite_des(satellite?.satelliteGroup?.['description']);
        setSatelliteData(satellite?.satelliteGroup);
        setOpenSatModal(true);
    }


    const edit_satellite = () => {
        setLoading(true)
        const sat = {
            ...satelliteData,
            name: satellite_name,
            description: satellite_des,
            satCount: Number(satellite_count),
            referenceOrbitParameters: {
                ...satelliteData.referenceOrbitParameters,
                altitude: Number(altitude),
                inclination: Number(inclination),
            }
        };

        if (parseInt(satellite_count) > 1) {
            sat.phasingType = phasingType === "TA" ? "InterPlanePhasing" : "PlanePhasing";
            sat.phasingAngle = phasing !== null ? parseFloat(`${phasing}`) : 360;
        } else {
            delete sat.phasingType; // Remove phasingType and phasingAngle if they exist
            delete sat.phasingAngle;
        }

        MissionService.edit_satellite(mission_id, satelliteData?.uniqueId, sat)?.then((res) => {
            if (res?.data) {
                MissionService.get_payload_by_sat_id(satelliteData?.uniqueId, mission_id)?.then((payloads) => {
                    if (payloads?.data || payloads?.data === null) {
                        MissionService.get_edge_by_sat_id(satelliteData?.uniqueId, mission_id)?.then((edges) => {
                            if (edges?.data || edges?.data === null) {
                                if (hasTruetwin) {
                                    setOpenSatModal(false)
                                    setHasTruetwin(false)
                                    showToastMessage('info', "Cannot edit satellite configuration if it has TrueTwin's")
                                    get_satellite_data()
                                } else {
                                    if (payloads?.data === null || payloads?.data?.length === 0) {
                                        return navigateTo(`${mission_name}/${mission_id}/${satelliteData?.['uniqueId']}/add_new_payload`, navigate)
                                    } else if (payloads?.data?.length > 4) {
                                        return navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${satelliteData?.['uniqueId']}/preview_payload`, navigate)
                                    } else if (!satelliteData?.['draftMode']) {
                                        return navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${satelliteData?.['uniqueId']}/review_satellite`, navigate)
                                    } else {
                                        return navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${satelliteData?.['uniqueId']}/add_new_template`, navigate)
                                    }
                                }
                            }
                            reset_selected_sat_data()
                        }).catch((e) => {
                            showToastMessage('error', "Error in getting edges")
                        })
                    }
                }).catch((e) => {
                    showToastMessage('error', "Error in getting payloads")
                })
            }
        }).catch((err) => {
            setLoading(false)
            if (err.response?.data) {
                showToastMessage('error', err.response?.data);
            } else {
                showToastMessage('error', "Something went wrong while updating satellite. Please try again.");
            }
        })
    }

    const getTotalSatelliteCount = (groups: any[]) => {
        let totalSatelliteCount = 0;
        groups && groups.forEach((group: any) => {
            totalSatelliteCount += group?.satelliteGroup?.satCount;
        });
        return totalSatelliteCount;
    }

    useEffect(() => {
        if (!mission_id) return
        get_satellite_data()
    }, [mission_id, tab_name])

    // Show success toast after navigation
    useEffect(() => {
        if (!loading && location.state?.SatelliteSuccessMessage) {
            showToastMessage('success', location.state.SatelliteSuccessMessage);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [loading, location.state?.SatelliteSuccessMessage, navigate])


    return (
        <Fragment>
            <div className="mission-card-view gap-3">
                {SatellitesDetails?.satelliteGroup?.length > 0 && SatellitesDetails?.satelliteGroup?.map((satellite, i) => {
                    const isEligibleForPromote = eligibleSatellites.includes(satellite?.satelliteGroup?.['uniqueId']);
                    return (
                        satellite?.satelliteGroup?.groupType?.type === "Group" &&
                        <div key={i} >
                            <div id={satellite?.satelliteGroup?.['name']} className="mission-card h-200 gap-2 d-flex flex-column justify-content-between" key={i}
                                onClick={(e) => {
                                    e.preventDefault();
                                    get_satellite_data()
                                    if (satellite?.satelliteGroup?.['draftMode']) {
                                        showToastMessage('info', 'Satellite configuration is incomplete. Edit to Configure.')
                                    } else {
                                        navigateTo_Sat_details(satellite?.satelliteGroup)
                                    }
                                }}>
                                <div className="d-flex justify-content-between w-100">
                                    <div className='d-flex flex-column w-80'>
                                        <div className="d-flex align-items-center gap-2 w-100">
                                            <img id={'satellite_icon'} src={require('../../../assets/images/sat_group.svg').default} width='20px' height='20px' alt={`Satellite`} />

                                            <span id={'satellite_name'} className={`text-truncate fs-20 color-atmos w-90`}>
                                                <CustomToolTip title={satellite?.satelliteGroup?.['name']} placement='top-start'>
                                                    {satellite?.satelliteGroup?.['name']}
                                                </CustomToolTip>
                                            </span>
                                        </div>
                                        <span className='text-gray text-truncate w-100'>
                                            <CustomToolTip title={satellite?.satelliteGroup?.['summery']}>
                                                {satellite?.satelliteGroup?.['summery']}
                                            </CustomToolTip>
                                        </span>
                                    </div >

                                    <div className="d-flex flex-row">
                                        <div
                                            className="d-flex align-items-center w-100"
                                            style={{
                                                gap: '8px',
                                                marginBottom: satellite?.satelliteGroup?.['draftMode'] ? '15px' : '3px',
                                                maxHeight: '25px'
                                            }}
                                        >
                                            <CustomToolTip title='No. of Satellites'>
                                                <div style={{ gap: '4px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                        <path d="M11.3599 7.29003C12.3351 7.2917 13.2816 6.95979 14.0419 6.34947C14.1276 6.28142 14.1979 6.19589 14.2479 6.09858C14.2979 6.00126 14.3266 5.89441 14.3321 5.78513C14.3385 5.66935 14.3202 5.55352 14.2782 5.44539C14.2363 5.33726 14.1718 5.23931 14.089 5.15809L11.9089 2.97912C12.2147 2.67344 12.5363 2.35208 12.8421 2.03856C12.9048 1.98369 12.9597 1.92883 13.0225 1.86612C13.0923 1.79185 13.1312 1.69374 13.1312 1.59179C13.1312 1.48985 13.0923 1.39174 13.0225 1.31746C12.986 1.28073 12.9426 1.25158 12.8949 1.23168C12.8471 1.21178 12.7958 1.20154 12.7441 1.20154C12.6923 1.20154 12.6411 1.21178 12.5933 1.23168C12.5455 1.25158 12.5021 1.28073 12.4657 1.31746C12.0893 1.68585 11.7285 2.05424 11.3521 2.42262L9.172 0.243654C9.08966 0.16235 8.99149 0.0988279 8.88357 0.0570299C8.77564 0.0152318 8.66028 -0.00394999 8.54463 0.000674965C8.43549 0.00700766 8.32888 0.0360786 8.23164 0.0860215C8.1344 0.135965 8.04869 0.205676 7.98 0.290682C7.32867 1.10387 6.99682 2.12677 7.04679 3.16724L5.90969 4.31159L4.08248 2.48533C4.01092 2.41093 3.92506 2.35175 3.83006 2.31132C3.73506 2.2709 3.63287 2.25006 3.52962 2.25006C3.42636 2.25006 3.32417 2.2709 3.22917 2.31132C3.13417 2.35175 3.04831 2.41093 2.97675 2.48533L0.561386 4.89944C0.415326 5.04629 0.333344 5.24495 0.333344 5.45202C0.333344 5.65909 0.415326 5.85774 0.561386 6.0046L2.39251 7.83086L2.07099 8.14438C1.68309 8.53366 1.46531 9.06068 1.46531 9.61009C1.46531 10.1595 1.68309 10.6865 2.07099 11.0758L3.25514 12.2593C3.44706 12.453 3.67547 12.6067 3.92717 12.7116C4.17888 12.8166 4.4489 12.8706 4.72161 12.8706C4.99433 12.8706 5.26434 12.8166 5.51605 12.7116C5.76776 12.6067 5.99617 12.453 6.18808 12.2593L6.50177 11.9458L8.32897 13.7721C8.4759 13.9181 8.67466 14 8.88184 14C9.08902 14 9.28778 13.9181 9.43471 13.7721L11.8501 11.3501C11.9961 11.2033 12.0781 11.0046 12.0781 10.7975C12.0781 10.5905 11.9961 10.3918 11.8501 10.245L10.0307 8.42655L11.1678 7.2822C11.2316 7.28856 11.2958 7.29118 11.3599 7.29003ZM1.11033 5.45594L3.53354 3.03399L5.3529 4.86025L2.94146 7.27436L1.11033 5.45594ZM11.2972 10.8015L8.88184 13.2156L7.05463 11.3893L9.47 8.97521L11.2972 10.8015ZM7.19579 4.13131C7.39415 4.84975 7.77606 5.50426 8.30402 6.03057C8.83198 6.55689 9.48783 6.93689 10.2072 7.13327L5.62737 11.7107C5.38596 11.9515 5.05879 12.0868 4.71769 12.0868C4.37659 12.0868 4.04943 11.9515 3.80801 11.7107L2.61601 10.5193C2.37504 10.278 2.2397 9.95101 2.2397 9.61009C2.2397 9.26916 2.37504 8.94217 2.61601 8.70088L7.19579 4.13131ZM8.85831 5.47161C8.24174 4.8634 7.87557 4.04635 7.83202 3.1816C7.78847 2.31685 8.0707 1.46717 8.62305 0.800153L11.0776 3.25345L13.54 5.71459L13.5557 5.73811C12.877 6.27885 12.0227 6.55061 11.1561 6.50145C10.2895 6.45229 9.47146 6.08564 8.85831 5.47161Z" fill="#F0F0F0" />
                                                    </svg>
                                                    <span className="iconText">{satellite?.satelliteGroup?.satCount}</span>
                                                </div>
                                            </CustomToolTip>
                                        </div>
                                        <span className="text-center align-middle" onClick={(e) => {
                                            e.stopPropagation()
                                            setShowBtnGroup('')
                                        }}>
                                            <ButtonGroup size="sm" className="flex-nowrap">

                                                {userData['resource_access']?.['ATMOS-RESOURCE-SERVER']?.['roles'][0] !== 'project_viewer' &&
                                                    <div className="btn-list more-button">
                                                        <Dropdown id="sat_edit_delete_btn" drop="end" show={showBtnGroup === satellite?.satelliteGroup?.['uniqueId']}>
                                                            <Dropdown.Toggle size="sm" variant="transparent" onClick={(e) => {
                                                                e.stopPropagation()
                                                                if (showBtnGroup === satellite?.satelliteGroup?.['uniqueId']) {
                                                                    setShowBtnGroup('')
                                                                } else {
                                                                    setShowBtnGroup(satellite?.satelliteGroup?.['uniqueId'])
                                                                }
                                                            }}>
                                                                <i className="fe fe-more-vertical fs-20"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {!satellite?.satelliteGroup?.['draftMode'] && <Dropdown.Item eventKey="0" id="view_sat"
                                                                    onClick={(e) => {
                                                                        navigate_to_view_satellite(satellite?.satelliteGroup)
                                                                    }}>
                                                                    View
                                                                </Dropdown.Item>
                                                                }
                                                                <Dropdown.Item eventKey="1" id="edit_sat"
                                                                    onClick={(e) => {
                                                                        handleEditSatelliteGroup(satellite)
                                                                    }}>
                                                                    Edit
                                                                </Dropdown.Item>
                                                                {!satellite?.satelliteGroup?.['draftMode'] &&
                                                                    <Dropdown.Item eventKey="2" id="clone_sat"
                                                                        onClick={() => {
                                                                            const TotalSatelliteCount = getTotalSatelliteCount(SatellitesDetails?.satelliteGroup)
                                                                            if (TotalSatelliteCount < maxSatelliteCount) {
                                                                                clone_existing_satellite_group(satellite?.satelliteGroup?.['uniqueId']);
                                                                            } else {
                                                                                showToastMessage('error', `Maximum satellite limit of ${maxSatelliteCount} reached. Contact your Administrator for support.`)
                                                                            }
                                                                        }}>
                                                                        Clone
                                                                    </Dropdown.Item>
                                                                }
                                                                {(userData?.['feature-allowed']?.['operate'] === 'Yes' && satellite?.satelliteGroup?.['satCount'] === 1 && !satellite?.satelliteGroup?.['draftMode']) &&
                                                                    <Dropdown.Item eventKey="3" id="promote_sat"
                                                                        disabled={!isEligibleForPromote}
                                                                        onClick={() => {
                                                                            setPromoteSatellite(satellite?.satelliteGroup);
                                                                        }}>
                                                                        {!isEligibleForPromote ? <i>Promoted</i> : 'Promote'}
                                                                    </Dropdown.Item>
                                                                }
                                                                <Dropdown.Item eventKey="4" id="delete_sat"
                                                                    onClick={(e) => {
                                                                        setSatelliteData(satellite?.satelliteGroup);
                                                                        setOpenDeleteModal(true);
                                                                    }}>
                                                                    Delete
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                }
                                            </ButtonGroup>
                                        </span >
                                    </div >
                                </div >

                                <div className={`d-flex gap-2 align-items-center me-3 mt-2`}>
                                    <span id={'payload_label'} className="satGroupPayloadTitle" >Payload</span>
                                    {satellite?.payloads?.length > 0 &&
                                        satellite?.payloads?.map((item, id) => {
                                            let payloadType = item?.['atmosData']?.['component_specific_attributes']?.['payloadType']
                                            if (id < 4) {
                                                return (
                                                    <CustomToolTip
                                                        title={item?.['userData']?.['payload_name']}
                                                        key={id}
                                                        placement="top"
                                                    >
                                                        <div id="payload_type" className='payload-hover-ani' onClick={(e) => {
                                                            e.stopPropagation()
                                                            if (satellite?.satelliteGroup?.['draftMode']) {
                                                                showToastMessage('info', 'Satellite configuration is incomplete. Edit to Configure.')
                                                            } else {
                                                                navigateTo(`${mission_name}/${mission_id}/${satellite?.satelliteGroup?.['name']}/${satellite?.satelliteGroup?.['uniqueId']}/payload_details/${item?.['userData']?.['payload_name']}/${item?.['uniqueId']}/${'Payloads'}`, navigate)
                                                            }
                                                        }}>
                                                            {payloadType === 'Earth Observation' && <img src={require('../../../assets/images/EarthObserve.svg').default} width='28px' height='28px' alt={payloadType} />}
                                                            {payloadType === 'Communication' && <img src={require('../../../assets/images/Communication.svg').default} width='28px' height='28px' alt={payloadType} />}
                                                            {payloadType === 'Other' && <img src={require('../../../assets/images/Other.svg').default} width='28px' height='28px' alt={payloadType} />}
                                                        </div>
                                                    </CustomToolTip>
                                                )
                                            }
                                        })}
                                    {satellite?.payloads?.length > 4 && <div className='payload-hover-ani'>
                                        <i className="fe fe-plus fs-12"></i>{satellite?.payloads?.length - 4}
                                    </div>}
                                    {!satellite?.payloads?.length && <div className="payloadEmptyState">NA</div>}
                                </div>
                                <div className={`mission-card-footer w-100 pt-2 mt-3`}>
                                    <TrueTwinIcon satellite={satellite} get_sat_info={get_satellite_data} navigateTo_Sat_details={navigateTo_Sat_details} handleEditSatelliteGroup={handleEditSatelliteGroup} setShowBtnGroup={setShowBtnGroup} />
                                </div>
                            </div >
                        </div >
                    )
                })}
                {userData['resource_access']?.['ATMOS-RESOURCE-SERVER']?.['roles'][0] !== 'project_viewer' &&
                    <div className="add-mission-card" onClick={() => {
                        const TotalSatelliteCount = getTotalSatelliteCount(SatellitesDetails?.satelliteGroup)
                        dispatch(setSatelliteEdit(false))
                        dispatch(setSatelliteClone(false))
                        if (TotalSatelliteCount < maxSatelliteCount) {
                            setSatellite_name('')
                            setSatelliteCount(!flagGroup ? 1 : null)
                            setAltitude(450)
                            setInclination(37)
                            setSatellite_des('')
                            setOpenSatModal(true)
                            setPhasing(null)
                            setPhasingType("TA")
                        } else {
                            showToastMessage('error', `Maximum satellite limit of ${maxSatelliteCount} reached. Contact your Administrator for support.`)
                        }
                    }}>
                        <div className="d-flex flex-row mt-2 align-items-center gap-2">
                            <AddNewEntityButton />
                            <span className="createGroupButton">Create</span>
                        </div>
                    </div>
                }
            </div>

            {openSatModel &&
                <CreateGroupModel
                    loading={loading}
                    close={() => {
                        reset_selected_sat_data();
                        setOpenSatModal(false);
                    }}
                    satellite_name={satellite_name}
                    setSatellite_name={setSatellite_name}
                    satellite_des={satellite_des}
                    setSatellite_des={setSatellite_des}
                    flagGroup={flagGroup}
                    setSatelliteCount={setSatelliteCount}
                    satellite_count={satellite_count}
                    inclination={inclination}
                    setInclination={setInclination}
                    phasing={phasing}
                    setPhasing={setPhasing}
                    phasingType={phasingType}
                    setPhasingType={setPhasingType}
                    altitude={altitude}
                    setAltitude={setAltitude}
                    onclick={() => {
                        satelliteEdit ? edit_satellite() : create_new_satellite()
                    }}
                    type={satelliteEdit ? 'Update' : 'Create'}
                    totalSat={getTotalSatelliteCount(SatellitesDetails?.satelliteGroup)}
                />
            }
            <ConfirmationDialog
                type='delete'
                open={openDeleteModel ? true : false}
                title={`Delete Satellite?`}
                description={`${satelliteData?.['trueTwinIds']?.length > 0 ? `The satellite has TrueTwins associated with it. Deleting ${satelliteData?.['name']} will permanently remove it from the database, and it cannot be restored once deleted.` : `Deleting ${satelliteData?.['name']} will permanently remove it from the database, and it cannot be restored once deleted.`}`}
                onCancel={() => setOpenDeleteModal(false)}
                onConfirm={() => {
                    deletesatellite(satelliteData);
                    setOpenDeleteModal(false);
                }}
                confirm_button_text={`Delete`}
            />
            {promoteSatellite && <OperateModal
                close={() => {
                    setPromoteSatellite(false)
                }}
                navigate_to_operate={navigate_to_operate}
                hasSelectedGroup={promoteSatellite}
                openModal={{ type: 'promote' }}
            />
            }
        </Fragment>
    )
}


const TrueTwinIcon = ({ satellite, get_sat_info, navigateTo_Sat_details, handleEditSatelliteGroup, setShowBtnGroup }) => {
    return (
        <div className='d-flex gap-2 align-items-center w-100 justify-content-between'>
            <div className='fs-13 d-flex gap-2 align-items-center' onClick={(e) => {
                e.stopPropagation()
            }}>
                <CustomToolTip
                    title={satellite?.satelliteGroup?.draftMode ? 'Satellite Not Configured' : 'Satellite is Configured'}
                    placement="top"
                >
                    <div className="d-flex gap-1">
                        <span className={`satStatusIndicator ${satellite?.satelliteGroup?.draftMode ? 'draft' : ''}`}></span>
                        <span id="create_true_twin" className='fs-14 d-flex' style={{ color: satellite?.satelliteGroup?.draftMode ? '#F2A93B' : '' }}>{satellite?.satelliteGroup?.draftMode ? 'Draft' : 'Configured'}</span>
                    </div>
                </CustomToolTip>
            </div >

            <div className='fs-13 d-flex gap-2 align-items-center color-atmos' onClick={(e) => {
                e.stopPropagation()
                get_sat_info()
                if (satellite?.satelliteGroup?.['draftMode']) {
                    setShowBtnGroup('')
                    handleEditSatelliteGroup(satellite)
                } else {
                    navigateTo_Sat_details(satellite?.satelliteGroup)
                }
            }}>
                <span>{`${satellite?.satelliteGroup?.['draftMode'] ? 'Configure' : 'View Details'}`}</span>
                <CustomToolTip
                    title={'View Details'}
                    placement="top"
                >
                    <span id="create_true_twin" className='fs-14 d-flex'>
                        {<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                            <path d="M1.83334 10.5L6.33334 6L1.83334 1.5" stroke="#C6FE02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>}
                    </span>
                </CustomToolTip>
            </div>
        </div>
    )

}

export default Satellites
